import React, { useEffect, useState } from 'react';
import {Paper, Box, Grid, Link as MuiLink, Typography, Container, TextField, Icon} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import LogoutButton from './logout_button';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BannerImage from './koaheader.png'; 

interface Props {
    loggedIn?: boolean
}

export default function Banner(props: Props) {
    const userinfo = {
        first: 'First Name'
    }

    const [NavBarToggle, setNavBarToggle] = useState(false)
    const toggleNavBar = () => {
        setNavBarToggle(!NavBarToggle)
    }

    const {loggedIn, watchDate, setWatchDate, user } = useAuth()
    const handleLoginSubmit = () => {
        
    }
    
    const [newWatchDate, setNewWatchDate] = useState(watchDate)
    return (
        <>
            <Box sx={{ bgcolor: "#ffffff", padding: 0, margin: "auto", textAlign: 'right', top: '0', width: '100%' }} maxWidth="lg">
                <MuiLink href="https://koa.ipac.caltech.edu" target="_blank"><img src={BannerImage} alt="KOA Banner" style={{ height: '100%' }} onClick={toggleNavBar}/></MuiLink>
            </Box>
        </>
    );
};
